import React from "react";
import type { ConfirmOptions } from "@app/services/confirm/types";
import type { ApiSpMovingData } from "@src/businessModules/Stock/api/storePlaces";
import {
    StockFinishedGoodsReceiptCancelConfirmContent,
    type StockFinishedGoodsReceiptCancelConfirmField,
} from "./StockFinishedGoodsReceiptCancelConfirmContent";

/** Параметры построения confirm-опций отмены размещения продукции. */
export interface BuildStockFinishedGoodsReceiptCancelConfirmParams {
    /** Движение, которое будет удалено. */
    movement: ApiSpMovingData;
    /** Поля контекста строки ВЗН УП. */
    fields: StockFinishedGoodsReceiptCancelConfirmField[];
}

/**
 * Формирует опции app-level confirm для отмены размещения продукции.
 * @param params движение и поля контекста
 */
export function buildStockFinishedGoodsReceiptCancelConfirmOptions(
    params: BuildStockFinishedGoodsReceiptCancelConfirmParams,
): ConfirmOptions {
    const { movement, fields } = params;

    return {
        title: "Отмена размещения",
        content: <StockFinishedGoodsReceiptCancelConfirmContent movement={movement} fields={fields} />,
        confirmText: "Удалить",
        cancelText: "Закрыть",
    };
}
